module.exports = (function(){
  const local = {
    apiUrl: 'http://localhost:3001/api/v1',
  }

  const remote = {
    prod: {
      apiUrl: 'https://consent-api.levelupify.com/api/v1',
    },
    dev: {
      apiUrl: 'https://consent-api.levelupify.fun/api/v1',
    }
  }

  const isLocal = () => {
    return /^localhost/.test(window.location.hostname);
  }

  const getProperty = (name) => {
    var data = isLocal() ? local : remote;
    if (!isLocal()) {
      if (window.location.hostname.indexOf('.fun') > -1) {
        return data['dev'][name]
      } else {
        return data['prod'][name]
      }
    }
    return data[name];
  };

  return {
    isLocal: isLocal(),
    apiUrl: getProperty('apiUrl'),
  }
})()


// WEBPACK FOOTER //
// ./src/config.js